import React from 'react';
import { BookOpenIcon } from 'lucide-react';
import { SectionCTA } from '../SectionCTA';
import { volumes } from '../../data/content';
export function Volumes() {
  return <section className="w-full bg-ink-deep px-4 py-14" data-id="element-226" data-mp="2x19uoe6joaa1">
      <div className="mx-auto w-full max-w-3xl" data-id="element-227" data-mp="2wzp22u3sj1et">
        <h2 className="text-center font-display text-[26px] font-extrabold leading-tight text-white sm:text-4xl" data-id="element-228" data-mp="2szycuutwwtce">
          What’s Inside{' '}
          <span className="italic text-gold-light" data-id="element-229" data-mp="2o26bla7dnuvj">Clinical Certainty Protocol™</span>?
        </h2>
        <p className="mt-3 text-center text-sm font-semibold uppercase tracking-[0.2em] text-gold-light" data-id="element-230" data-mp="2j8ah4hqboq54">
          The 6-Volume Clinical System
        </p>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-231" data-mp="29byzdc7yr83a">
          {volumes.map(volume => <article key={volume.number} className="rounded-3xl border border-white/10 bg-white/[0.04] p-5" data-id="element-232" data-mp="25alylgjq9v38">
              <div className="flex items-center gap-2" data-id="element-233" data-mp="20d3x2b81ii59">
                <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-gold/20" data-id="element-234" data-mp="335e3xoqnpqe2">
                  <BookOpenIcon className="h-4 w-4 text-gold-light" aria-hidden="true" data-id="element-235" data-mp="37wmeio3q3hst" />
                </span>
                <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-gold-light" data-id="element-236" data-mp="2u6932brmhkyq">
                  {volume.number}
                </span>
              </div>
              <h3 className="mt-3 font-display text-xl font-bold leading-snug text-white" data-id="element-237" data-mp="3lvlwxe0n70gj">
                {volume.title}
              </h3>
              <p className="mt-1 text-[13px] font-semibold text-gold-light/90" data-id="element-238" data-mp="3quff3jqvjfn1">
                {volume.subtitle}
              </p>
              <p className="mt-2 text-[14px] leading-relaxed text-white/70" data-id="element-239" data-mp="3huiimvy8tchf">
                {volume.description}
              </p>
            </article>)}
        </div>

        <div className="mt-8 rounded-3xl border border-gold/30 bg-gold/10 p-5 text-center" data-id="element-240" data-mp="21idb1kd00h8a">
          <p className="font-display text-lg font-bold text-white" data-id="element-241" data-mp="26gog7hscm3k6">
            This Is Not Just Information…
          </p>
          <p className="mt-2 text-[14px] leading-relaxed text-white/75" data-id="element-242" data-mp="7023hres1kvj">
            It’s a decision-making system you can apply immediately in your practice.
          </p>
        </div>

        <SectionCTA headline="Get all 6 volumes in your hands in under 2 minutes." dark data-id="element-243" data-mp="26z7zdqfw1cp" />
      </div>
    </section>;
}